export default __webpack_public_path__ + "static/img/10.e078b07.png";